<template class="full-height">
  <div class="member-container full-height">
    <!-- 編輯簡介 -->
    <el-dialog
      :top="dialogTopMargin"
      v-loading="listLoading"
      :visible.sync="dialogIntroFormVisible"
      :title="roleSettingObj.id ? '編輯內容' : '新增內容'"
      @closed="onDialogClosed"
    >
      <el-card class="box-card">
        <el-form
          :rules="introRules"
          size="mini"
          ref="introductionForm"
          :model="roleSettingObj"
          :label-width="formLabelWidth"
        >
          <el-form-item v-if="false" :label="'種類'" prop="dataKey">
            <el-input
              v-model="roleSettingObj.dataKey"
              maxlength="50"
              show-word-limit
              :disabled="true"
            ></el-input>
          </el-form-item>

          <el-form-item :label="'內容'" prop="introduction">
            <el-input
              type="textarea"
              v-model="roleSettingObj.dataValue"
              :autosize="{ minRows: 4, maxRows: 30 }"
            ></el-input>
          </el-form-item>

          <!--          <el-form-item :label="'排序'" prop="sort">-->
          <!--            <el-input v-model="roleSettingObj.sort"></el-input>-->
          <!--          </el-form-item>-->
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveIntroduction('introductionForm')">確定</el-button>
        <el-button type="danger" @click="onDialogClosed">取消</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0" class="full-height">
      <div style="padding-bottom: 0">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item> </el-form-item>
        </el-form>
      </div>

      <div style="position: relative; height: 80%">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
          @sort-change="sortChange"
        >
          <el-table-column :label="'ID'" prop="id" sortable="custom" align="center" width="80">
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'種類'" prop="name" sortable="custom" align="center" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.dataKey === 'AdultText' ? '不雅文字限制' : row.dataKey }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'內容'" prop="mail" align="center" width="1070">
            <template slot-scope="{ row }">
              <span>{{ row.dataValue }}</span>
            </template>
          </el-table-column>

          <!--          <el-table-column :label="'順序'" prop="roles" sortable="custom" align="center" width="130">-->
          <!--            <template slot-scope="{ row }">-->
          <!--              <span>{{ row.sort.toString() }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->

          <el-table-column
            :label="'更新時間'"
            prop="roles"
            sortable="custom"
            align="center"
            width="160"
          >
            <template slot-scope="{ row }">
              <span>{{ row.updateDT ? row.updateDT.toString() : '' }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="success"
                icon="el-icon-edit"
                @click="editIntroductionInfo(scope.row)"
                :disabled="false"
              >
                編輯內容
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        style="padding-top: 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { getAdultTextBlocking, saveAdultTextBlocking } from '@/api/tcSetting'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
import Upload from '@/views/ita/components/fileUpload.vue'
import checkPermission from '@/utils/permission' // 权限判断函数
var defaultFormData = {
  id: null,
  dataKey: null,
  dataValue: null,
  sort: 1,
  createDT: null,
  updateDT: null,
}

export default {
  name: 'Member',
  components: { Pagination, Upload },
  directives: { waves },
  filters: {},
  props: {
    pageRoles: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {},
  data() {
    return {
      rules: {
        dataValue: [{ required: true, message: '內容不可為空', trigger: 'blur' }],
      },
      introRules: {},
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      showPwdInupt: false,
      funcName: '帳號管理',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      rolesSelected: [],
      roleSettingObj: {},
      rolesList: [],
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        roles: this.pageRoles,
        page: 1,
        limit: 30,
        sort: '-cUpdateDT',
      },
      dialogIntroFormVisible: false,
      selectedUser: null,
    }
  },
  async created() {
    await this.getList()
  },
  methods: {
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading !== action) {
        vm.listLoading = action
      }
    },
    checkPermission,
    async editIntroductionInfo(row) {
      //透過api取得
      let vm = this
      vm.listLoading = true
      vm.selectedUser = row.id

      vm.roleSettingObj = JSON.parse(JSON.stringify(row))

      vm.listLoading = false
      vm.dialogIntroFormVisible = true
    },
    // 儲存內容
    saveIntroduction(formName) {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      this.$refs[formName].validate(async valid => {
        if (valid) {
          vm.loadingHanlder(true)
          const payload = JSON.parse(JSON.stringify(vm.roleSettingObj))
          console.log(payload)

          await saveAdultTextBlocking(payload)
            .then(response => {
              vm.onDialogClosed()
              vm.loadingHanlder(false)
              this.$message({
                message: '操作成功',
                type: 'success',
              })
            })
            .catch(error => {})
        }
        await this.getList()
      })
    },
    // 取得內容
    async getList() {
      this.loadingHanlder(true)
      var res = await getAdultTextBlocking()
      console.log(res)
      this.list = res.data.data
      this.total = res.data.total
      this.loadingHanlder(false)
    },
    // 關閉Dialog
    onDialogClosed() {
      this.dialogIntroFormVisible = false
    },

    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}
</style>
